/**
 * Context menu builder.
 *
 * @author Erik Galloway <egalloway@boltsystem.com>
 */
export default class ContextMenuBuilder {
    /**
     * Make a new ContextMenuBuilder instance.
     *
     * @param {GridApi} api
     * @param {Object} params
     */
    constructor(api, params) {
        this.api = api
        this.params = params
        this.items = []
    }

    /**
     * Set the context menu items.
     *
     * @param {Array} items
     * @return {ContextMenuBuilder}
     */
    setItems(items = []) {
        this.items = items

        return this
    }

    /**
     * Get the collection of context menu item objects.
     *
     * @return {Array}
     */
    toArray() {
        return this.items.map((MenuItem) => {
            const item = new MenuItem(this.api, this.params)

            return item.toObject()
        })
    }
}
